import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { isPC } from '@/utils/common'
import { useAppStore } from '@/store/app'
import { useUserStore } from '@/store/user'
import { useInviteStore } from '@/store/invite'
import { storeToRefs } from 'pinia';
import MobileHome from '@/views/yidian/Home/MobileHome.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Website',
    redirect: () => {
      // 根据设备类型重定向到相应页面
      // 移动端优先首屏可见，不在重定向阶段抢占网络做预加载
      return isPC() ? '/' : '/m/home'
    }
  },
  {
    path: '/',
    name: 'Website',
    component: () => import('@/views/yidian/website/index.vue'),
    meta: { title:'一点PPT官网' },
  },
  {
    path: '/m/Website',
    name: 'MobileWebsite',
    component: () => import('@/views/yidian/website/website.vue'),
    meta: { title:'一点PPT官网' },
  },
  {
    path: '/Home',
    name: 'HomePage',
    component: () => import('@/views/yidian/Home/index.vue'),
     meta: { title:'一点PPT官网 - 一键生成PPT模板，快速制作PPT' },
     children: [
      {
        path: '/Home',
        name: 'homeDetail',
        component: () => import('@/views/yidian/Home/homeDetail.vue'),
        meta: { title:'首页' },
      },
      {
        path: '/Production',
        name: 'Production',
        component: () => import('@/views/yidian/Home/Production.vue'),
        meta: { title:'工作台' },
      },
      {
        path: '/Template',
        name: 'Template',
        component: () => import('@/views/yidian/Home/Template.vue'),
        meta: { title:'模板页' },
      },

     ]
  },
  {
    path: '/preview',
    name: 'PPTPreview',
    component: () => import('@/views/yidian/Tools/PPTPreview.vue'),
    meta: { title:'PPT预览' },
  },
  {
    path: '/m/home',
    name: 'MobileHome',
    component: MobileHome,
     meta: { title:'一点PPT官网 - 一键生成PPT模板，快速制作PPT' },
  },
  {
    path: '/m/notification',
    name: 'MobileNotification',
    component: () => import('@/views/yidian/Home/MobileNotification.vue'),
    meta: { title: '消息通知' },
  },
  {
    path: '/m/Template',
    name: 'MobileTemplate',
    component: () => import('@/views/yidian/Home/MobileTemplate.vue'),
     meta: { title:'模板' },
  },
  {
    path: '/m/essential',
    name: 'MobileEssential',
    component: () => import('@/views/yidian/Home/MobileEssential.vue'),
    meta: { title:'大学生竞选班干部必备PPT' },
  },
  {
    path: '/m/Template/detail',
    name: 'MobileTemplateDetail',
    component: () => import('@/views/yidian/Tools/mobileTemplateDetail.vue'),
     meta: { title:'模板详情' },
  },
  {
    path: '/m/template/create',
    name: 'mobileTemplateCreate',
    component: () => import('@/views/yidian/Tools/mobileTemplateCreate.vue'),
     meta: { title:'模板创建' },
  },
  {
    path: '/m/Production',
    name: 'MobileProduction',
    component: () => import('@/views/yidian/Home/MobileProduction.vue'),
     meta: { title:'作品' },
  },
  {
    path: '/m/create', 
    name: 'MobileCreate',
    component: () => import('@/views/yidian/Tools/mobileCreate.vue'),
     meta: { title:'生成大纲' },
  },
  {
    path: '/m/search',
    name: 'mobileSearchTools',
    component: () => import('@/views/yidian/Tools/mobileSearchTools.vue'),
     meta: { title:'搜索页' },
  },
  {
    path: '/m/Integral',
    name: 'MobileIntegral',
    component: () => import('@/views/yidian/User/mobileIntegral.vue'),
    meta: { title: '积分明细' }
  },
  {
    path: '/m/invite',
    name: 'MobileInvite',
    component: () => import('@/views/yidian/Invite/mobileInvite.vue'),
    meta: { title: '邀请有礼' }
  },
  {
    path: '/m/my-coupon',
    name: 'MyCouponMobile',
    component: () => import('@/views/yidian/Home/MyCouponMobile.vue'),
    meta: { title: '我的优惠券' }
  },
  {
    path: '/m/coupon-center',
    name: 'CouponCenterMobile',
    component: () => import('@/views/yidian/Home/CouponCenterMobile.vue'),
    meta: { title: '领券中心' }
  },
  {
    path: '/feedback',
    name: 'feedBcaks',
    component: () => import('@/components/YiDian/templateModal/index.vue'),
    meta: { title: '反馈' }
  },
  {
    path: '/m/EquityComparison',
    name: 'EquityComparison',
    component: () => import('@/views/yidian/User/EquityComparison.vue'),
    meta: { title: '会员权益' }

  },
  {
    path: '/m/Member',
    name: 'mobileMember',
    component: () => import('@/views/yidian/User/mobileMember.vue'),
    meta: { title: '会员中心' }
  },
  {
    path: '/m/open-link',
    name: 'MobileOpenLink',
    component: () => import('@/views/yidian/Tools/mobileOpenLink.vue'),
    meta: { title: '外部链接' }
  },
  {
    path: '/activities',
    name: 'Activities',
    component: () => import('@/views/yidian/Activities/index.vue'),
    meta: { title: '活动' }
  },
  {
    path: '/activities-sdk',
    name: 'activitiesSdk',
    component: () => import('@/views/yidian/Activities/activitiesSdk.vue'),
    meta: { title: '活动' }
  },
  // {
  //   path: '/feedback',
  //   name: 'feedBcaks',
  //   component: MobileHome,
  //   meta: { title: '反馈' }
  // },
  {
    path: '/editor',
    name: 'Editor',
    component: () => import('@/views/yidian/Editor/index.vue')
  },
  // {
  //   path: '/screen',
  //   name: 'Screen',
  //   component: Screen
  // },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () => import('@/views/Mobile/index.vue')
  },
  {
    path: '/m/deregister',
    name: 'Deregister',
    component: () => import('@/views/yidian/User/Deregister.vue'),
    meta: { title: '注销' }
  },
  {
      path: '/m/bindPhone',
      name: 'BindPhone',
      component: () => import('@/views/yidian/BindPhone/index.vue'),
      meta: { title: '绑定手机' }
    },
    {
    path: '/m/edit-passward',
    name: 'MobileEditPassward',
    component: () => import('@/views/yidian/User/mobileEditPassward.vue'),
    meta: { title: '修改密码' }
  },
  {
    path: '/m/teenager',
    name: 'Teenager',
    component: () => import('@/views/yidian/Teenager/index.vue'),
    meta: { title: '青少年模式 ' }
  },
  {
    path: '/m/teenager/password',
    name: 'TeenagerPassword',
    component: () => import('@/views/yidian/Teenager/password.vue'),
    meta: { title: '青少年模式修改密码 ' }
  },
   {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: () => import('@/views/yidian/User/userAgreement.vue'),
    meta: { title: '用户协议 ' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/yidian/User/privacyPolicy.vue'),
    meta: { title: '隐私政策' }
  },
  {
    path: '/child-privacy-policy',
    name: 'ChildPrivacyPolicy',
    component: () => import('@/views/yidian/User/childPrivacyPolicy.vue'),
    meta: { title: '儿童隐私保护政策' }
  },
  {
    path: '/third-party-sdk-list',
    name: 'ThirdPartySdk',
    component: () => import('@/views/yidian/User/thirdPartySdk.vue'),
    meta: { title: '第三方共享与SDK清单' }
  },
   {
    path: '/pay-policy',
    name: 'PayPolicy',
    component: () => import('@/views/yidian/User/payPolicy.vue'),
    meta: { title: '付费协议' }
  },
     {
    path: '/integral-rule',
    name: 'IntegralRule',
    component: () => import('@/views/yidian/User/IntegralRule.vue'),
    meta: { title: '积分规则' }
  },
    {
    path: '/outer-Expert',
    name: 'OuterExpert',
    component: () => import('@/views/yidian/outer/form.vue'),
    meta: { title: '信息收集表' }
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('@/views/yidian/Invite/index.vue'),
    meta: { title: '邀请有礼' }
  },
  {
    path: '/member',
    name: 'MemberPage',
    component: () => import('@/views/yidian/Member/index.vue'),
    meta: { title: '会员中心' }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isPCDevice = isPC()
  const userStore = useUserStore()
  const inviteStore = useInviteStore()
  const { userInfo } = storeToRefs(userStore)
  // 优先从目标路由 query 缓存邀请码，避免跳转丢参后登录拿不到 inviteCode
  inviteStore.cacheInviteCodeFromCurrentUrl(to.query.code || to.query.inviteCode)
    // const token = getToken()
    // debugger
   // 判断是否是移动端
  if (isPCDevice && Object.keys(userInfo.value).length === 0 && (to.path === '/') ) {
    next()
  } else if(isPCDevice && Object.keys(userInfo.value).length > 0 && (to.path === '/')) {
    next({ path: '/Home', query: to.query, hash: to.hash })
  } else if (!isPCDevice && Object.keys(userInfo.value).length === 0 &&  to.path === '/') {
    next({ path: '/m/Website', query: to.query, hash: to.hash })
  } else {
    next()
  }
})

const defaultRouteTitle = 'AI生成PPT_在线一键生成PPT工具'
const getDynamicRouteTitle = (to:any) => {
  // if (to.path === '/home/tools/detail') {
  //     const toolName = decodeMaybeURIComponent(to.query.toolName)
  //     if (toolName) return getRouteTitle(toolName)
  // }
  // if (to.path === '/ppt/preview') return getRouteTitle('PPT预览')
  // if (to.path === '/ppt/Home/Production') return getRouteTitle('PPT工作台')
  // if (to.path === '/ppt/Home/Template') return getRouteTitle('PPT模板页')
  // if (to.path === '/ppt/Home' || to.path.startsWith('/ppt/tool/')) return getRouteTitle('PPT制作')

  return to.meta.title || 'AI生成PPT' + '_在线一键生成PPT工具'
}
// 路由加载后
router.afterEach((to) => {
  // 根据路由元信息设置文档标题
  window.document.title = getDynamicRouteTitle(to) || defaultRouteTitle
})

export default router
